import RecaptchaWrapper from "./recaptcha-wrapper";
import ReCAPTCHA from "./recaptcha";
export default RecaptchaWrapper;
export { ReCAPTCHA };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-google-recaptcha/lib/esm/index.js
// module id = 885
// module chunks = 0